const brandCodes = {
  Britz: 'B',
  Maui: 'M',
  Mighty: 'Y',
  RoadBear: 'R',
  MonteRV: 'E',
  JustGo: 'J',
  Apollo: 'A',
  BunkCampers: 'N',
  Cheapa: 'C',
  Hippie: 'H',
};

export default brandCodes;
